export default "__VITE_ASSET__7b3f0042__"